/* eslint-disable @typescript-eslint/no-explicit-any */
const removeUndefinedValues = (params: any): any => {
  return Object.keys(params).reduce((previousValue, currentValue) => {
    const acc: any = previousValue;
    if (params[currentValue] !== undefined) {
      acc[currentValue] = params[currentValue];
    }
    return acc;
  }, {});
};

export const MiscUtils = {
  removeUndefinedValues,
};
